import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { AuthFrame } from "./AuthFrame";
import { useSession } from "../../services/SessionContext";

export function SignInPage() {
  const { signIn, repo } = useSession();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  function submit(event: React.FormEvent) {
    event.preventDefault();
    setError("");
    try {
      signIn(email, password);
      navigate("/app/dashboard");
    } catch (err) {
      setError(err instanceof Error ? err.message : "Sign in failed.");
    }
  }

  function demo() {
    const credentials = repo.demoCredentials();
    signIn(credentials.email, credentials.password);
    navigate("/app/dashboard");
  }

  return (
    <AuthFrame title="Sign in" subtitle="Open your company event repository.">
      <form className="space-y-4" onSubmit={submit}>
        <div className="space-y-2">
          <Label htmlFor="email">Email</Label>
          <Input
            id="email"
            autoComplete="email"
            inputMode="email"
            required
            value={email}
            onChange={(event) => setEmail(event.target.value)}
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="password">Password</Label>
          <Input
            id="password"
            autoComplete="current-password"
            required
            type="password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
          />
        </div>
        {error ? <p className="text-sm font-medium text-red-700">{error}</p> : null}
        <Button className="w-full" type="submit">
          Sign in
        </Button>
        <Button className="w-full" type="button" variant="secondary" onClick={demo}>
          View Demo
        </Button>
      </form>
      <div className="mt-5 flex justify-between text-sm">
        <Link className="text-navy-900 hover:underline" to="/auth/forgot-password">
          Forgot password
        </Link>
        <Link className="text-navy-900 hover:underline" to="/auth/sign-up">
          Create account
        </Link>
      </div>
    </AuthFrame>
  );
}
